module.exports = __webpack_public_path__ + "img/orders.2a543b1f.svg";